import React, { useState, useEffect } from 'react';
import {
  Box,
  Card,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TablePagination,
  IconButton,
  Tooltip,
  Button,
  Chip,
  TextField,
  InputAdornment,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Alert,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  
  Typography,
  Paper,
  CircularProgress,
  Switch,
  FormControlLabel,
  Snackbar,
  useMediaQuery,
  useTheme,
  CardContent,
  CardActions,
  Divider,
  Stack,
  Fade,
  Zoom,
  Badge
} from '@mui/material';
// MUI v7 : le `Grid` par défaut a perdu les props `item` / `xs` / `md`
// au profit de `size={{...}}`. Ce fichier utilise l'ancienne API.
import { GridLegacy as Grid } from '@mui/material';
import {
  Add as AddIcon,
  Edit as EditIcon,
  Delete as DeleteIcon,
  Visibility as ViewIcon,
  Search as SearchIcon,
  LocationOn as LocationIcon,
  Phone as PhoneIcon,
  Email as EmailIcon,
  Business as BusinessIcon,
  CheckCircle as ActiveIcon,
  Cancel as InactiveIcon,
  Home as HomeIcon,
  Refresh as RefreshIcon,
  Person as PersonIcon,
  CalendarToday as CalendarIcon,
  Close as CloseIcon,
  FilterList as FilterIcon,
  Sort as SortIcon,
  MoreVert as MoreVertIcon
} from '@mui/icons-material';
import api from '../services/auth';
import { getCurrentUser } from '../services/auth';
import { format, parseISO } from 'date-fns';
import { fr } from 'date-fns/locale';

const Succursale = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const isTablet = useMediaQuery(theme.breakpoints.between('sm', 'md'));
  const isDesktop = useMediaQuery(theme.breakpoints.up('md'));

  const [succursales, setSuccursales] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(isMobile ? 5 : 10);
  const [search, setSearch] = useState('');
  const [openDialog, setOpenDialog] = useState(false);
  const [selectedSuccursale, setSelectedSuccursale] = useState(null);
  const [dialogMode, setDialogMode] = useState('add');
  const [entreprises, setEntreprises] = useState([]);
  const [managers, setManagers] = useState([]);
  const [loadingManagers, setLoadingManagers] = useState(false);
  const [actionLoading, setActionLoading] = useState(false);
  const [currentUser, setCurrentUser] = useState(null);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState('');
  const [snackbarSeverity, setSnackbarSeverity] = useState('success');
  const [mobileMenuAnchor, setMobileMenuAnchor] = useState(null);
  const [selectedMobileSuccursale, setSelectedMobileSuccursale] = useState(null);
  const [showFilters, setShowFilters] = useState(false);
  const [filters, setFilters] = useState({
    status: 'all',
    mainBranch: 'all'
  });

  // Form state
  const [formData, setFormData] = useState({
    entreprise: '',
    nom: '',
    adresse: '',
    telephone: '',
    email: '',
    manager: '',
    is_active: true,
    is_main_branch: false,
    // date_ouverture: format(new Date(), 'yyyy-MM-dd'),
    // date_fermeture: ''
  });

  const [formErrors, setFormErrors] = useState({});

  // Récupérer l'utilisateur connecté au montage
  useEffect(() => {
    const user = getCurrentUser();
    console.log('Utilisateur connecté:', user);
    setCurrentUser(user);
    
    if (!user) {
      window.location.href = '/login';
      return;
    }
    
    fetchSuccursales();
    fetchManagers();
  }, []);

  // Ajuster rowsPerPage sur mobile
  useEffect(() => {
    setRowsPerPage(isMobile ? 5 : 10);
  }, [isMobile]);

  const showSnackbar = (message, severity = 'success') => {
    setSnackbarMessage(message);
    setSnackbarSeverity(severity);
    setSnackbarOpen(true);
  };

  const handleSnackbarClose = () => {
    setSnackbarOpen(false);
  };

  const fetchSuccursales = async () => {
    try {
      setLoading(true);
      const response = await api.get('/succursales/');
      
      let data = [];
      if (Array.isArray(response.data)) {
        data = response.data;
      } else if (response.data?.results) {
        data = response.data.results;
      } else if (response.data?.data) {
        data = response.data.data;
      }
      
      setSuccursales(data);
      setError('');
    } catch (err) {
      console.error('Erreur succursales:', err);
      let errorMsg = 'Erreur lors du chargement des succursales';
      
      if (err.response?.status === 401) {
        errorMsg = 'Session expirée, veuillez vous reconnecter';
      } else if (err.response?.status === 403) {
        errorMsg = 'Permission refusée';
      } else if (err.response?.data?.detail) {
        errorMsg = err.response.data.detail;
      }
      
      setError(errorMsg);
      setSuccursales([]);
    } finally {
      setLoading(false);
    }
  };

  const fetchManagers = async () => {
    try {
      setLoadingManagers(true);
      console.log('Récupération des managers depuis /succursales/available_managers/');
      
      const response = await api.get('/succursales/available_managers/');
      console.log('Réponse managers:', response.data);
      
      let managersData = [];
      
      if (Array.isArray(response.data)) {
        managersData = response.data;
      } else if (response.data && typeof response.data === 'object') {
        const possibleKeys = ['results', 'data', 'managers', 'available_managers', 'users'];
        for (const key of possibleKeys) {
          if (Array.isArray(response.data[key])) {
            managersData = response.data[key];
            console.log(`Données trouvées dans la clé: ${key}`);
            break;
          }
        }
        
        if (managersData.length === 0) {
          managersData = Object.values(response.data).filter(item => 
            item && typeof item === 'object' && (item.id || item.pk)
          );
        }
      }
      
      console.log(`Nombre de managers récupérés: ${managersData.length}`);
      
      const formattedManagers = managersData
        .map(manager => {
          if (!manager || typeof manager !== 'object') return null;
          
          return {
            id: manager.id || manager.pk || manager.user_id,
            username: manager.username || manager.email || `Manager ${manager.id}`,
            first_name: manager.first_name || '',
            last_name: manager.last_name || '',
            email: manager.email || '',
            role: manager.role || 'manager',
            full_name: manager.first_name && manager.last_name 
              ? `${manager.first_name} ${manager.last_name}`
              : manager.username || 'Manager'
          };
        })
        .filter(manager => manager && manager.id);
      
      console.log('Managers formatés:', formattedManagers);
      setManagers(formattedManagers);
      
    } catch (err) {
      console.error('Erreur lors de la récupération des managers:', err);
      
      if (err.response?.status === 404 || err.response?.status === 500) {
        console.log('Endpoint spécifique échoué, tentative avec /users/');
        try {
          const fallbackResponse = await api.get('/users/');
          
          let fallbackUsers = [];
          if (Array.isArray(fallbackResponse.data)) {
            fallbackUsers = fallbackResponse.data;
          } else if (fallbackResponse.data?.results) {
            fallbackUsers = fallbackResponse.data.results;
          } else if (fallbackResponse.data?.data) {
            fallbackUsers = fallbackResponse.data.data;
          }
          
          const filteredManagers = fallbackUsers.filter(user => 
            user && (user.role === 'manager' || user.role === 'proprietaire' || user.role === 'super_admin')
          );
          
          const formattedFallbackManagers = filteredManagers.map(user => ({
            id: user.id,
            username: user.username || user.email,
            first_name: user.first_name || '',
            last_name: user.last_name || '',
            email: user.email || '',
            role: user.role || 'user',
            full_name: user.first_name && user.last_name 
              ? `${user.first_name} ${user.last_name}`
              : user.username || 'Utilisateur'
          }));
          
          console.log('Managers fallback:', formattedFallbackManagers);
          setManagers(formattedFallbackManagers);
          
        } catch (fallbackErr) {
          console.error('Erreur fallback:', fallbackErr);
          setManagers([]);
        }
      } else {
        setManagers([]);
      }
    } finally {
      setLoadingManagers(false);
    }
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleSearch = (event) => {
    setSearch(event.target.value);
    setPage(0);
  };

  const handleOpenDialog = (mode, succursale = null) => {
    setDialogMode(mode);
    setSelectedSuccursale(succursale);
    setFormErrors({});
    
    if (mode === 'edit' || mode === 'view') {
      setFormData({
        entreprise: succursale.entreprise?.id || succursale.entreprise || '',
        nom: succursale.nom || '',
        adresse: succursale.adresse || '',
        telephone: succursale.telephone || '',
        email: succursale.email || '',
        manager: succursale.manager?.id || succursale.manager || '',
        is_active: succursale.is_active,
        is_main_branch: succursale.is_main_branch,
        // date_ouverture: succursale.date_ouverture
        //   ? format(parseISO(succursale.date_ouverture), 'yyyy-MM-dd')
        //   : format(new Date(), 'yyyy-MM-dd'),
        // date_fermeture: succursale.date_fermeture
        //   ? format(parseISO(succursale.date_fermeture), 'yyyy-MM-dd')
        //   : ''
      });
    } else {
      const newFormData = {
        entreprise: '',
        nom: '',
        adresse: '',
        telephone: '',
        email: '',
        manager: '',
        is_active: true,
        is_main_branch: false,
        // date_ouverture: format(new Date(), 'yyyy-MM-dd'),
        // date_fermeture: ''
      };
      
      if (currentUser && currentUser.role !== 'super_admin' && currentUser.entreprise) {
        newFormData.entreprise = currentUser.entreprise;
      }
      
      setFormData(newFormData);
    }
    
    setOpenDialog(true);
  };

  const handleCloseDialog = () => {
    setOpenDialog(false);
    setSelectedSuccursale(null);
    setFormErrors({});
  };

  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value
    }));
    
    if (formErrors[name]) {
      setFormErrors(prev => ({
        ...prev,
        [name]: ''
      }));
    }
  };

  const handleSwitchChange = (e) => {
    const { name, checked } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: checked
    }));
  };

  const validateForm = () => {
    const errors = {};
    
    if (!formData.entreprise) errors.entreprise = 'Entreprise requise';
    if (!formData.nom?.trim()) errors.nom = 'Nom requis';
    if (!formData.adresse?.trim()) errors.adresse = 'Adresse requise';
    // if (!formData.date_ouverture) errors.date_ouverture = "Date d'ouverture requise";
    
    // Validation des dates
    // if (formData.date_ouverture && formData.date_fermeture) {
    //   if (new Date(formData.date_fermeture) < new Date(formData.date_ouverture)) {
    //     errors.date_fermeture = 'La date de fermeture ne peut pas être antérieure à la date d\'ouverture';
    //   }
    // }
    
    if (formData.telephone && !/^[\d\s\+\-\(\)]{8,20}$/.test(formData.telephone)) {
      errors.telephone = 'Numéro de téléphone invalide';
    }
    
    if (formData.email && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)) {
      errors.email = 'Email invalide';
    }
    
    setFormErrors(errors);
    return Object.keys(errors).length === 0;
  };

  const handleSubmit = async () => {
    if (!validateForm()) {
      showSnackbar('Veuillez corriger les erreurs dans le formulaire', 'error');
      return;
    }
    
    setActionLoading(true);
    
    try {
      const dataToSend = {
        ...formData,
        manager: formData.manager || null,
        date_fermeture: formData.date_fermeture || null
      };
      
      console.log('Données envoyées:', dataToSend);
      
      if (dialogMode === 'add') {
        const response = await api.post('/succursales/', dataToSend);
        console.log('Succursale créée:', response.data);
        showSnackbar('Succursale créée avec succès', 'success');
      } else if (dialogMode === 'edit') {
        const response = await api.put(`/succursales/${selectedSuccursale.id}/`, dataToSend);
        console.log('Succursale modifiée:', response.data);
        showSnackbar('Succursale modifiée avec succès', 'success');
      }
      
      await fetchSuccursales();
      handleCloseDialog();
      
    } catch (err) {
      console.error('Erreur enregistrement:', err);
      
      if (err.response?.status === 400) {
        const apiErrors = err.response.data;
        console.error('Erreurs de validation:', apiErrors);
        
        const formattedErrors = {};
        Object.keys(apiErrors).forEach(key => {
          if (Array.isArray(apiErrors[key])) {
            formattedErrors[key] = apiErrors[key].join(', ');
          } else {
            formattedErrors[key] = apiErrors[key];
          }
        });
        
        setFormErrors(formattedErrors);
        showSnackbar('Erreurs de validation, vérifiez le formulaire', 'error');
      } else if (err.response?.status === 403) {
        showSnackbar('Permission refusée', 'error');
      } else if (err.response?.status === 401) {
        showSnackbar('Session expirée', 'error');
      } else if (err.response?.status === 500) {
        showSnackbar('Erreur serveur, veuillez réessayer', 'error');
      } else {
        showSnackbar('Erreur lors de l\'enregistrement', 'error');
      }
    } finally {
      setActionLoading(false);
    }
  };

  const handleDelete = async (id) => {
    if (!window.confirm('Êtes-vous sûr de vouloir supprimer cette succursale ?')) return;
    
    setActionLoading(true);
    
    try {
      await api.delete(`/succursales/${id}/`);
      showSnackbar('Succursale supprimée avec succès', 'success');
      await fetchSuccursales();
      
    } catch (err) {
      console.error('Erreur suppression:', err);
      
      if (err.response?.status === 403) {
        showSnackbar('Permission refusée pour la suppression', 'error');
      } else if (err.response?.status === 400) {
        showSnackbar('Impossible de supprimer cette succursale', 'error');
      } else if (err.response?.status === 401) {
        showSnackbar('Session expirée', 'error');
      } else if (err.response?.status === 500) {
        showSnackbar('Erreur serveur lors de la suppression', 'error');
      } else {
        showSnackbar('Erreur lors de la suppression', 'error');
      }
    } finally {
      setActionLoading(false);
    }
  };

  const handleToggleStatus = async (id, currentStatus) => {
    setActionLoading(true);
    
    try {
      await api.patch(`/succursales/${id}/`, {
        is_active: !currentStatus
      });
      
      await fetchSuccursales();
      showSnackbar(`Succursale ${!currentStatus ? 'activée' : 'désactivée'} avec succès`, 'success');
      
    } catch (err) {
      console.error('Erreur changement statut:', err);
      
      if (err.response?.status === 401) {
        showSnackbar('Session expirée', 'error');
      } else {
        showSnackbar('Erreur lors du changement de statut', 'error');
      }
    } finally {
      setActionLoading(false);
    }
  };

  const handleSetMainBranch = async (id) => {
    if (!window.confirm('Définir cette succursale comme succursale principale ?')) return;
    
    setActionLoading(true);
    
    try {
      await api.patch(`/succursales/${id}/set_main_branch/`);
      
      await fetchSuccursales();
      showSnackbar('Succursale définie comme principale', 'success');
      
    } catch (err) {
      console.error('Erreur succursale principale:', err);
      
      if (err.response?.status === 401) {
        showSnackbar('Session expirée', 'error');
      } else {
        showSnackbar('Erreur lors du changement de succursale principale', 'error');
      }
    } finally {
      setActionLoading(false);
    }
  };

  const handleRefresh = () => {
    fetchSuccursales();
    fetchManagers();
    showSnackbar('Données actualisées', 'info');
  };

  const handleMobileMenuOpen = (event, succursale) => {
    setMobileMenuAnchor(event.currentTarget);
    setSelectedMobileSuccursale(succursale);
  };

  const handleMobileMenuClose = () => {
    setMobileMenuAnchor(null);
    setSelectedMobileSuccursale(null);
  };

  const canCreateSuccursale = () => {
    if (!currentUser) return false;
    return currentUser.role === 'super_admin' || 
           currentUser.role === 'proprietaire' || 
           currentUser.role === 'manager';
  };

  const canEditSuccursale = (succursale) => {
    if (!currentUser) return false;
    if (currentUser.role === 'super_admin') return true;
    if (currentUser.role === 'proprietaire' && currentUser.entreprise === succursale.entreprise) return true;
    if (currentUser.role === 'manager' && succursale.manager === currentUser.id) return true;
    return false;
  };

  const canDeleteSuccursale = (succursale) => {
    if (!currentUser) return false;
    if (succursale.is_main_branch) return false;
    if (currentUser.role === 'super_admin') return true;
    if (currentUser.role === 'proprietaire' && currentUser.entreprise === succursale.entreprise) return true;
    return false;
  };

  const safeSuccursales = Array.isArray(succursales) ? succursales : [];

  const filteredSuccursales = safeSuccursales.filter(succursale => {
    if (!succursale) return false;
    
    const searchLower = search.toLowerCase();
    const entrepriseNom = succursale.entreprise_details?.nom || '';
    const managerNom = succursale.manager_details?.username || '';
    
    const matchesSearch = (
      (succursale.nom?.toLowerCase() || '').includes(searchLower) ||
      (succursale.code?.toLowerCase() || '').includes(searchLower) ||
      (succursale.adresse?.toLowerCase() || '').includes(searchLower) ||
      entrepriseNom.toLowerCase().includes(searchLower) ||
      managerNom.toLowerCase().includes(searchLower)
    );
    
    const matchesStatus = filters.status === 'all' || 
      (filters.status === 'active' && succursale.is_active) ||
      (filters.status === 'inactive' && !succursale.is_active);
    
    const matchesMainBranch = filters.mainBranch === 'all' ||
      (filters.mainBranch === 'main' && succursale.is_main_branch) ||
      (filters.mainBranch === 'secondary' && !succursale.is_main_branch);
    
    return matchesSearch && matchesStatus && matchesMainBranch;
  });

  const paginatedSuccursales = filteredSuccursales.slice(
    page * rowsPerPage,
    page * rowsPerPage + rowsPerPage
  );

  const formatDate = (dateString) => {
    if (!dateString) return '-';
    try {
      return format(parseISO(dateString), 'dd/MM/yyyy', { locale: fr });
    } catch (e) {
      return dateString;
    }
  };

  const getManagerNom = (succursale) => {
    if (succursale.manager_details) {
        if (succursale.manager_details.username) 
            return succursale.manager_details.username;
        if (succursale.manager_details.first_name && succursale.manager_details.last_name) 
            return `${succursale.manager_details.first_name} ${succursale.manager_details.last_name}`;
        if (succursale.manager_details.email) 
            return succursale.manager_details.email;
        if (succursale.manager_details.nom) 
            return succursale.manager_details.nom;
    }
    
    if (succursale.manager_name) 
        return succursale.manager_name;
    
    if (succursale.manager && typeof succursale.manager === 'object') {
        if (succursale.manager.username) 
            return succursale.manager.username;
        if (succursale.manager.first_name && succursale.manager.last_name) 
            return `${succursale.manager.first_name} ${succursale.manager.last_name}`;
        if (succursale.manager.email) 
            return succursale.manager.email;
        if (succursale.manager.nom) 
            return succursale.manager.nom;
    }
    
    if (succursale.manager && typeof succursale.manager === 'number') {
        const foundManager = managers.find(m => m.id === succursale.manager);
        if (foundManager) {
            return foundManager.first_name && foundManager.last_name
                ? `${foundManager.first_name} ${foundManager.last_name}`
                : foundManager.username || foundManager.email || `Manager #${succursale.manager}`;
        }
        return `Manager #${succursale.manager}`;
    }
    
    if (succursale.manager_name) {
        return succursale.manager_name;
    }
    
    return 'Non assigné';
  };

  // Composant de carte pour mobile
  const MobileSuccursaleCard = ({ succursale }) => (
    <Zoom in={true} style={{ transitionDelay: '100ms' }}>
      <Card sx={{ mb: 2, borderRadius: '12px', position: 'relative' }}>
        <CardContent>
          <Box display="flex" justifyContent="space-between" alignItems="flex-start">
            <Box flex={1}>
              <Box display="flex" alignItems="center" gap={1} mb={1}>
                {succursale.is_main_branch && (
                  <Tooltip title="Succursale principale">
                    <HomeIcon fontSize="small" sx={{ color: 'warning.main' }} />
                  </Tooltip>
                )}
                <Typography variant="h6" fontWeight="bold">
                  {succursale.nom}
                </Typography>
                <Chip 
                  label={succursale.code || 'N/A'} 
                  size="small"
                  color="primary"
                  variant="outlined"
                  sx={{ ml: 'auto' }}
                />
              </Box>
              
              <Divider sx={{ my: 1.5 }} />
              
              <Stack spacing={1.5}>
                <Box display="flex" alignItems="center" gap={1}>
                  <LocationIcon fontSize="small" sx={{ color: 'text.secondary' }} />
                  <Typography variant="body2" color="text.secondary">
                    {succursale.adresse || 'Adresse non renseignée'}
                  </Typography>
                </Box>
                
                <Box display="flex" alignItems="center" gap={1}>
                  <PersonIcon fontSize="small" sx={{ color: 'text.secondary' }} />
                  <Typography variant="body2" color="text.secondary">
                    Manager: {getManagerNom(succursale)}
                  </Typography>
                </Box>
                
                <Box display="flex" alignItems="center" gap={1}>
                  <CalendarIcon fontSize="small" sx={{ color: 'text.secondary' }} />
                  <Typography variant="body2" color="text.secondary">
                    Ouverture: {formatDate(succursale.date_ouverture)}
                  </Typography>
                </Box>
                
                {succursale.date_fermeture && (
                  <Box display="flex" alignItems="center" gap={1}>
                    <CloseIcon fontSize="small" sx={{ color: 'text.secondary' }} />
                    <Typography variant="body2" color="text.secondary">
                      Fermeture: {formatDate(succursale.date_fermeture)}
                    </Typography>
                  </Box>
                )}
              </Stack>
              
              <Box mt={2}>
                <Chip
                  icon={succursale.is_active ? <ActiveIcon /> : <InactiveIcon />}
                  label={succursale.is_active ? 'Active' : 'Inactive'}
                  color={succursale.is_active ? 'success' : 'error'}
                  size="small"
                  variant="outlined"
                  sx={{ fontWeight: 'medium' }}
                />
              </Box>
            </Box>
          </Box>
        </CardContent>
        
        <CardActions sx={{ justifyContent: 'flex-end', pt: 0 }}>
          <Tooltip title="Voir détails">
            <IconButton
              size="small"
              onClick={() => handleOpenDialog('view', succursale)}
              color="info"
              disabled={actionLoading}
            >
              <ViewIcon />
            </IconButton>
          </Tooltip>
          
          {canEditSuccursale(succursale) && (
            <Tooltip title="Modifier">
              <IconButton
                size="small"
                onClick={() => handleOpenDialog('edit', succursale)}
                color="primary"
                disabled={actionLoading}
              >
                <EditIcon />
              </IconButton>
            </Tooltip>
          )}
          
          {!succursale.is_main_branch && canEditSuccursale(succursale) && (
            <Tooltip title="Définir comme principale">
              <IconButton
                size="small"
                onClick={() => handleSetMainBranch(succursale.id)}
                color="warning"
                disabled={actionLoading}
              >
                <HomeIcon />
              </IconButton>
            </Tooltip>
          )}
          
          {canDeleteSuccursale(succursale) && (
            <Tooltip title="Supprimer">
              <IconButton
                size="small"
                onClick={() => handleDelete(succursale.id)}
                color="error"
                disabled={actionLoading}
              >
                <DeleteIcon />
              </IconButton>
            </Tooltip>
          )}
        </CardActions>
      </Card>
    </Zoom>
  );

  if (loading && !currentUser) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" height="400px">
        <CircularProgress />
        <Typography sx={{ ml: 2 }}>Chargement...</Typography>
      </Box>
    );
  }

  return (
    <Box sx={{ 
      p: { xs: 1, sm: 2, md: 3 },
      minHeight: '100vh',
      bgcolor: 'background.default'
    }}>
      <Card sx={{ 
        p: { xs: 1.5, sm: 2, md: 3 },
        mb: 3,
        borderRadius: { xs: '8px', sm: '12px' },
        boxShadow: { xs: 2, md: 3 }
      }}>
        {/* En-tête */}
        <Box sx={{ 
          display: 'flex', 
          flexDirection: { xs: 'column', sm: 'row' },
          justifyContent: 'space-between', 
          alignItems: { xs: 'flex-start', sm: 'center' },
          mb: 3,
          gap: 2
        }}>
          <Box>
            <Typography 
              variant={isMobile ? "h6" : "h5"} 
              component="h1" 
              sx={{ fontWeight: 'bold' }}
            >
              <BusinessIcon sx={{ mr: 1, verticalAlign: 'middle', fontSize: isMobile ? 24 : 28 }} />
              Gestion des Succursales
            </Typography>
            <Typography variant="body2" color="text.secondary">
              {filteredSuccursales.length} succursale(s) trouvée(s)
            </Typography>
          </Box>
          
          <Box display="flex" gap={1} flexWrap="wrap">
            <Tooltip title="Actualiser">
              <Button
                variant="outlined"
                size={isMobile ? "small" : "medium"}
                startIcon={<RefreshIcon />}
                onClick={handleRefresh}
                disabled={actionLoading || loading}
              >
                {!isMobile && "Actualiser"}
              </Button>
            </Tooltip>
            
            <Tooltip title="Filtrer">
              <Button
                variant="outlined"
                size={isMobile ? "small" : "medium"}
                startIcon={<FilterIcon />}
                onClick={() => setShowFilters(!showFilters)}
                color={showFilters ? 'primary' : 'inherit'}
              >
                {!isMobile && "Filtres"}
              </Button>
            </Tooltip>
            
            {canCreateSuccursale() && (
              <Tooltip title="Ajouter une succursale">
                <Button
                  variant="contained"
                  size={isMobile ? "small" : "medium"}
                  startIcon={<AddIcon />}
                  onClick={() => handleOpenDialog('add')}
                  disabled={actionLoading}
                >
                  {!isMobile && "Nouvelle Succursale"}
                </Button>
              </Tooltip>
            )}
          </Box>
        </Box>

        {/* Filtres */}
        <Fade in={showFilters}>
          <Paper 
            sx={{ 
              p: 2, 
              mb: 2, 
              bgcolor: 'grey.50',
              display: showFilters ? 'block' : 'none'
            }}
          >
            <Grid container spacing={2} alignItems="center">
              <Grid item xs={12} sm={6} md={4}>
                <FormControl fullWidth size="small">
                  <InputLabel>Statut</InputLabel>
                  <Select
                    value={filters.status}
                    onChange={(e) => setFilters({...filters, status: e.target.value})}
                    label="Statut"
                  >
                    <MenuItem value="all">Tous</MenuItem>
                    <MenuItem value="active">Actifs</MenuItem>
                    <MenuItem value="inactive">Inactifs</MenuItem>
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={12} sm={6} md={4}>
                <FormControl fullWidth size="small">
                  <InputLabel>Type</InputLabel>
                  <Select
                    value={filters.mainBranch}
                    onChange={(e) => setFilters({...filters, mainBranch: e.target.value})}
                    label="Type"
                  >
                    <MenuItem value="all">Toutes</MenuItem>
                    <MenuItem value="main">Principales</MenuItem>
                    <MenuItem value="secondary">Secondaires</MenuItem>
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={12} md={4}>
                <Button 
                  fullWidth 
                  variant="outlined" 
                  onClick={() => setFilters({status: 'all', mainBranch: 'all'})}
                >
                  Réinitialiser
                </Button>
              </Grid>
            </Grid>
          </Paper>
        </Fade>

        {error && (
          <Alert severity="error" sx={{ mb: 2 }} onClose={() => setError('')}>
            {error}
          </Alert>
        )}

        {/* Barre de recherche */}
        <Box mb={3}>
          <TextField
            fullWidth
            variant="outlined"
            placeholder={isMobile ? "Rechercher..." : "Rechercher par nom, code, adresse, entreprise ou manager..."}
            value={search}
            onChange={handleSearch}
            size={isMobile ? "small" : "medium"}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon />
                </InputAdornment>
              ),
              endAdornment: search && (
                <InputAdornment position="end">
                  <IconButton size="small" onClick={() => setSearch('')}>
                    <CloseIcon fontSize="small" />
                  </IconButton>
                </InputAdornment>
              )
            }}
          />
        </Box>

        {/* Liste des succursales - Vue mobile vs desktop */}
        {isMobile ? (
          // Vue mobile - Cartes
          <Box>
            {loading ? (
              <Box display="flex" justifyContent="center" alignItems="center" py={4}>
                <CircularProgress />
              </Box>
            ) : paginatedSuccursales.length > 0 ? (
              paginatedSuccursales.map((succursale) => (
                <MobileSuccursaleCard key={succursale.id} succursale={succursale} />
              ))
            ) : (
              <Paper sx={{ p: 4, textAlign: 'center' }}>
                <Typography color="text.secondary">
                  {search ? 'Aucune succursale ne correspond à votre recherche' : 'Aucune succursale trouvée'}
                </Typography>
              </Paper>
            )}
          </Box>
        ) : (
          // Vue desktop - Tableau
          <Paper sx={{ width: '100%', overflow: 'auto', borderRadius: '8px' }}>
            <Table sx={{ minWidth: 650 }}>
              <TableHead>
                <TableRow sx={{ bgcolor: 'primary.main' }}>
                  <TableCell sx={{ color: 'white', fontWeight: 'bold' }}>Code</TableCell>
                  <TableCell sx={{ color: 'white', fontWeight: 'bold' }}>Nom</TableCell>
                  <TableCell sx={{ color: 'white', fontWeight: 'bold' }}>Adresse</TableCell>
                  <TableCell sx={{ color: 'white', fontWeight: 'bold' }}>Manager</TableCell>
                  <TableCell sx={{ color: 'white', fontWeight: 'bold' }}>Statut</TableCell>
                  <TableCell sx={{ color: 'white', fontWeight: 'bold' }}>Ouverture</TableCell>
                  <TableCell sx={{ color: 'white', fontWeight: 'bold' }}>Fermeture</TableCell>
                  <TableCell sx={{ color: 'white', fontWeight: 'bold' }}>Actions</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {loading ? (
                  <TableRow>
                    <TableCell colSpan={8} align="center" sx={{ py: 4 }}>
                      <CircularProgress size={24} sx={{ mr: 2 }} />
                      <Typography color="text.secondary">Chargement...</Typography>
                    </TableCell>
                  </TableRow>
                ) : paginatedSuccursales.length > 0 ? (
                  paginatedSuccursales.map((succursale) => (
                    <TableRow 
                      key={succursale.id}
                      hover
                      sx={{ opacity: succursale.is_active ? 1 : 0.7 }}
                    >
                      <TableCell>
                        <Chip 
                          label={succursale.code || 'N/A'} 
                          size="small"
                          color="primary"
                          variant="outlined"
                        />
                      </TableCell>
                      <TableCell>
                        <Box display="flex" alignItems="center">
                          {succursale.is_main_branch && (
                            <Tooltip title="Succursale principale">
                              <HomeIcon fontSize="small" sx={{ mr: 1, color: 'warning.main' }} />
                            </Tooltip>
                          )}
                          <Typography variant="body2" fontWeight="medium">
                            {succursale.nom}
                          </Typography>
                        </Box>
                      </TableCell>
                      <TableCell>
                        <Tooltip title={succursale.adresse}>
                          <Typography variant="body2" noWrap sx={{ maxWidth: 200 }}>
                            {succursale.adresse || 'N/A'}
                          </Typography>
                        </Tooltip>
                      </TableCell>
                      <TableCell>
                        <Typography variant="body2">
                          {getManagerNom(succursale)}
                        </Typography>
                      </TableCell>
                      <TableCell>
                        <Chip
                          icon={succursale.is_active ? <ActiveIcon /> : <InactiveIcon />}
                          label={succursale.is_active ? 'Active' : 'Inactive'}
                          color={succursale.is_active ? 'success' : 'error'}
                          size="small"
                          variant="outlined"
                          onClick={canEditSuccursale(succursale) ? () => handleToggleStatus(succursale.id, succursale.is_active) : undefined}
                          sx={{ cursor: canEditSuccursale(succursale) ? 'pointer' : 'default' }}
                        />
                      </TableCell>
                      <TableCell>
                        <Typography variant="body2">
                          {formatDate(succursale.date_ouverture)}
                        </Typography>
                      </TableCell>
                      <TableCell>
                        <Typography variant="body2">
                          {formatDate(succursale.date_fermeture)}
                        </Typography>
                      </TableCell>
                      <TableCell>
                        <Box display="flex" gap={0.5}>
                          <Tooltip title="Voir">
                            <IconButton
                              size="small"
                              onClick={() => handleOpenDialog('view', succursale)}
                              color="info"
                              disabled={actionLoading}
                            >
                              <ViewIcon fontSize="small" />
                            </IconButton>
                          </Tooltip>
                          
                          {canEditSuccursale(succursale) && (
                            <Tooltip title="Modifier">
                              <IconButton
                                size="small"
                                onClick={() => handleOpenDialog('edit', succursale)}
                                color="primary"
                                disabled={actionLoading}
                              >
                                <EditIcon fontSize="small" />
                              </IconButton>
                            </Tooltip>
                          )}
                          
                          {!succursale.is_main_branch && canEditSuccursale(succursale) && (
                            <Tooltip title="Définir comme principale">
                              <IconButton
                                size="small"
                                onClick={() => handleSetMainBranch(succursale.id)}
                                color="warning"
                                disabled={actionLoading}
                              >
                                <HomeIcon fontSize="small" />
                              </IconButton>
                            </Tooltip>
                          )}
                          
                          {canDeleteSuccursale(succursale) && (
                            <Tooltip title="Supprimer">
                              <IconButton
                                size="small"
                                onClick={() => handleDelete(succursale.id)}
                                color="error"
                                disabled={actionLoading}
                              >
                                <DeleteIcon fontSize="small" />
                              </IconButton>
                            </Tooltip>
                          )}
                        </Box>
                      </TableCell>
                    </TableRow>
                  ))
                ) : (
                  <TableRow>
                    <TableCell colSpan={8} align="center" sx={{ py: 4 }}>
                      <Typography color="text.secondary">
                        {search ? 'Aucune succursale ne correspond à votre recherche' : 'Aucune succursale trouvée'}
                      </Typography>
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </Paper>
        )}
        
        {/* Pagination */}
        {filteredSuccursales.length > 0 && (
          <TablePagination
            rowsPerPageOptions={isMobile ? [5, 10] : [5, 10, 25]}
            component="div"
            count={filteredSuccursales.length}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
            labelRowsPerPage={isMobile ? "Lignes:" : "Lignes par page:"}
            sx={{ mt: 2 }}
          />
        )}
      </Card>

      {/* Dialog pour ajouter/modifier/voir */}
      <Dialog 
        open={openDialog} 
        onClose={handleCloseDialog}
        maxWidth="md"
        fullWidth
        fullScreen={isMobile}
        PaperProps={{
          sx: { borderRadius: isMobile ? 0 : '12px' }
        }}
      >
        <DialogTitle sx={{ 
          bgcolor: 'primary.main', 
          color: 'white',
          p: { xs: 2, sm: 3 }
        }}>
          <Box display="flex" alignItems="center" justifyContent="space-between">
            <Box display="flex" alignItems="center">
              {dialogMode === 'add' ? <AddIcon sx={{ mr: 1 }} /> : 
               dialogMode === 'edit' ? <EditIcon sx={{ mr: 1 }} /> : 
               <ViewIcon sx={{ mr: 1 }} />}
              <Typography variant={isMobile ? "h6" : "h5"} component="span">
                {dialogMode === 'add' ? 'Nouvelle Succursale' : 
                 dialogMode === 'edit' ? 'Modifier la Succursale' : 
                 'Détails de la Succursale'}
              </Typography>
            </Box>
            {isMobile && (
              <IconButton onClick={handleCloseDialog} sx={{ color: 'white' }}>
                <CloseIcon />
              </IconButton>
            )}
          </Box>
          
          {selectedSuccursale?.code && (
            <Typography variant="caption" sx={{ display: 'block', mt: 1, opacity: 0.9 }}>
              Code: {selectedSuccursale.code}
            </Typography>
          )}
        </DialogTitle>
        
        <DialogContent sx={{ mt: 2, p: { xs: 2, sm: 3 } }}>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="Nom *"
                name="nom"
                value={formData.nom}
                onChange={handleInputChange}
                error={!!formErrors.nom}
                helperText={formErrors.nom}
                disabled={dialogMode === 'view' || actionLoading}
                size={isMobile ? "small" : "medium"}
              />
            </Grid>
            
            <Grid item xs={12}>
              <TextField
                fullWidth
                label="Adresse *"
                name="adresse"
                value={formData.adresse}
                onChange={handleInputChange}
                multiline
                rows={2}
                error={!!formErrors.adresse}
                helperText={formErrors.adresse}
                disabled={dialogMode === 'view' || actionLoading}
                size={isMobile ? "small" : "medium"}
              />
            </Grid>
            
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="Téléphone"
                name="telephone"
                value={formData.telephone}
                onChange={handleInputChange}
                error={!!formErrors.telephone}
                helperText={formErrors.telephone}
                disabled={dialogMode === 'view' || actionLoading}
                size={isMobile ? "small" : "medium"}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <PhoneIcon fontSize="small" />
                    </InputAdornment>
                  ),
                }}
              />
            </Grid>
            
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="Email"
                name="email"
                type="email"
                value={formData.email}
                onChange={handleInputChange}
                error={!!formErrors.email}
                helperText={formErrors.email}
                disabled={dialogMode === 'view' || actionLoading}
                size={isMobile ? "small" : "medium"}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <EmailIcon fontSize="small" />
                    </InputAdornment>
                  ),
                }}
              />
            </Grid>
            
            <Grid item xs={12} sm={6}>
              <FormControl 
                fullWidth 
                disabled={dialogMode === 'view' || actionLoading}
                error={!!formErrors.manager}
                size={isMobile ? "small" : "medium"}
              >
                <InputLabel>Manager</InputLabel>
                <Select
                  name="manager"
                  value={formData.manager}
                  onChange={handleInputChange}
                  label="Manager"
                >
                  <MenuItem value="">
                    <em>Aucun manager</em>
                  </MenuItem>
                  
                  {loadingManagers ? (
                    <MenuItem disabled>
                      <CircularProgress size={16} sx={{ mr: 1 }} />
                      Chargement...
                    </MenuItem>
                  ) : managers.length === 0 ? (
                    <MenuItem disabled>Aucun manager disponible</MenuItem>
                  ) : (
                    managers.map((manager) => (
                      <MenuItem key={manager.id} value={manager.id}>
                        {manager.first_name && manager.last_name 
                          ? `${manager.first_name} ${manager.last_name}`
                          : manager.username || `Manager ${manager.id}`}
                      </MenuItem>
                    ))
                  )}
                </Select>
                
                {formErrors.manager && (
                  <Typography variant="caption" color="error">
                    {formErrors.manager}
                  </Typography>
                )}
              </FormControl>
            </Grid>
            
            {/* <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="Date d'ouverture *"
                name="date_ouverture"
                type="date"
                value={formData.date_ouverture}
                onChange={handleInputChange}
                error={!!formErrors.date_ouverture}
                helperText={formErrors.date_ouverture}
                disabled={dialogMode === 'view' || actionLoading}
                InputLabelProps={{ shrink: true }}
                size={isMobile ? "small" : "medium"}
              />
            </Grid> */}
            
            {/* <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="Date de fermeture"
                name="date_fermeture"
                type="date"
                value={formData.date_fermeture}
                onChange={handleInputChange}
                disabled={dialogMode === 'view' || actionLoading}
                InputLabelProps={{ shrink: true }}
                helperText="Optionnel - Laisser vide si toujours active"
                size={isMobile ? "small" : "medium"}
                error={!!formErrors.date_fermeture}
              />
              {formErrors.date_fermeture && (
                <Typography variant="caption" color="error">
                  {formErrors.date_fermeture}
                </Typography>
              )}
            </Grid> */}
            
            {dialogMode !== 'view' && (
              <>
                <Grid item xs={12} sm={6}>
                  <FormControlLabel
                    control={
                      <Switch
                        checked={formData.is_active}
                        onChange={handleSwitchChange}
                        name="is_active"
                        color="primary"
                        disabled={actionLoading}
                      />
                    }
                    label="Succursale active"
                  />
                </Grid>
                
                <Grid item xs={12} sm={6}>
                  <FormControlLabel
                    control={
                      <Switch
                        checked={formData.is_main_branch}
                        onChange={handleSwitchChange}
                        name="is_main_branch"
                        color="warning"
                        disabled={actionLoading}
                      />
                    }
                    label="Succursale principale"
                  />
                </Grid>
              </>
            )}
            
            {Object.keys(formErrors).length > 0 && (
              <Grid item xs={12}>
                <Alert severity="error">
                  {Object.values(formErrors).map((error, index) => (
                    <div key={index}>• {error}</div>
                  ))}
                </Alert>
              </Grid>
            )}
          </Grid>
        </DialogContent>
        
        {dialogMode !== 'view' && !isMobile && (
          <DialogActions sx={{ p: 3, borderTop: '1px solid rgba(0, 0, 0, 0.12)' }}>
            <Button onClick={handleCloseDialog} disabled={actionLoading}>
              Annuler
            </Button>
            <Button 
              onClick={handleSubmit} 
              variant="contained"
              disabled={actionLoading}
              startIcon={actionLoading && <CircularProgress size={20} />}
            >
              {dialogMode === 'add' ? 'Créer' : 'Enregistrer'}
            </Button>
          </DialogActions>
        )}
        
        {dialogMode !== 'view' && isMobile && (
          <Box sx={{ p: 2, borderTop: '1px solid rgba(0, 0, 0, 0.12)', display: 'flex', gap: 1 }}>
            <Button fullWidth onClick={handleCloseDialog} disabled={actionLoading} variant="outlined">
              Annuler
            </Button>
            <Button 
              fullWidth 
              onClick={handleSubmit} 
              variant="contained"
              disabled={actionLoading}
              startIcon={actionLoading && <CircularProgress size={20} />}
            >
              {dialogMode === 'add' ? 'Créer' : 'Enregistrer'}
            </Button>
          </Box>
        )}
        
        {dialogMode === 'view' && !isMobile && (
          <DialogActions sx={{ p: 3 }}>
            <Button onClick={handleCloseDialog} variant="contained">
              Fermer
            </Button>
          </DialogActions>
        )}
      </Dialog>

      {/* Snackbar pour les notifications */}
      <Snackbar
        open={snackbarOpen}
        autoHideDuration={4000}
        onClose={handleSnackbarClose}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
      >
        <Alert 
          onClose={handleSnackbarClose} 
          severity={snackbarSeverity} 
          variant="filled"
          sx={{ width: '100%' }}
        >
          {snackbarMessage}
        </Alert>
      </Snackbar>
    </Box>
  );
};

export default Succursale;